import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useTheme } from '@mui/material/styles';
import AkygaLogoNew from 'static/AkygaComponents_nowe niebieski.svg';
import AkygaDarkLogo from 'static/logo_dark.webp';
import { useTranslation } from 'react-i18next';
import useCategoryGroups from 'Hooks/useCategoryGroups';
import { useCookieConsent } from 'context/CookieConsentContext';

const Footer = () => {
  const theme = useTheme();
  const { mode } = theme.palette;
  const date = new Date();
  const year = date.getFullYear();
  const { t } = useTranslation();
  const { resetConsent } = useCookieConsent();

  const { data: categories = [] } = useCategoryGroups();

  return (
    <Grid container spacing={2} sx={{ fontSize: '0.75rem' }}>
      <Grid item xs={12} sm={6}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ color: 'primary.main', fontSize: '1rem' }}
            >
              {t('footer.catalogue')}
            </Typography>
            {categories.map((category, index) => (
              <React.Fragment key={index}>
                <Link
                  href={`/products/${category.ids}`}
                  color="textSecondary"
                  underline="hover"
                >
                  {t(`footer.filters.${category.label}`)}
                </Link>
                <br />
              </React.Fragment>
            ))}
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ color: 'primary.main', fontSize: '1rem' }}
            >
              {t('footer.aboutUs')}
            </Typography>
            <Link href="/certificates" color="textSecondary" underline="hover">
              {t('footer.certificates')}
            </Link>
            <br />
            <Link href="/distributors" color="textSecondary" underline="hover">
              {t('footer.aboutDistributors')}
            </Link>
            <br />
            <Link href="/blog" color="textSecondary" underline="hover">
              {t('footer.blog')}
            </Link>
            <br />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ color: 'primary.main', fontSize: '1rem' }}
            >
              {t('footer.contactUs')}
            </Typography>
            <Link href="/contact" color="textSecondary" underline="hover">
              {t('footer.contact')}
            </Link>
            <br />
            <Link href="/basket" color="textSecondary" underline="hover">
              {t('footer.sendInquiry')}
            </Link>
            <br />
            <Link
              href="mailto:sales@akygacomponents.com"
              color="textSecondary"
              underline="hover"
            >
              sales@akygacomponents.com
            </Link>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Box
          display={'flex'}
          justifyContent={'flex-end'}
          alignItems={'center'}
          width={1}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Box display={'flex'} flexDirection="row" alignItems="flex-start">
            <Link
              href="/cookie-policy"
              color="textSecondary"
              underline="hover"
              marginRight={2}
            >
              {t('footer.cookiesPolicy')}
            </Link>
            |
            <Link
              href="/privacy-policy"
              color="textSecondary"
              underline="hover"
              marginLeft={2}
              marginRight={2}
            >
              {t('footer.privacyPolicy')}
            </Link>
            |
            <Link
              component="button"
              type="button"
              sx={{ textTransform: 'none', marginLeft: 2 }}
              onClick={resetConsent}
              color="textSecondary"
              underline="hover"
            >
              {t('footer.manageCookiePreferences')}
            </Link>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ bgcolor: theme.palette.primary.main, marginY: 2 }} />
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          width={1}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Box display={'flex'} alignItems={'left'} flexDirection="column">
            <Box display={'flex'} alignItems={'center'}>
              <Link
                href="https://www.linkedin.com/company/ropla-elektronik/"
                color="primary"
              >
                <LinkedInIcon />
              </Link>
            </Box>
            <Typography
              align={'center'}
              variant={'caption'}
              color="text.secondary"
              component={'p'}
            >
              &copy; Akyga Group {year}. {t('footer.allRightsReserved')}
            </Typography>
          </Box>
          <Box display={'flex'} component="a" href="/" title="Akyga" width={80}>
            <Box
              component={'img'}
              src={mode === 'light' ? AkygaLogoNew : AkygaDarkLogo}
              height={1}
              width={1}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Footer;
